// Package Imports
import React from 'react';
import { Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';

// Project Imports
import ConfigStyle from 'core/constants/ConfigStyle';
import regex from 'core/constants/Regex';
import { TextAreaInputProps } from 'components/textarea/type';

const TextAreaInput = ({
  label,
  name,
  required,
  rows,
  onlyChars,
  style,
  onChange,
  message,
  rules,
  disabled,
  value,
}: TextAreaInputProps) => (
  <div
    className={
      disabled
        ? 'floating-disabled relative custom-border'
        : 'relative custom-border'
    }
  >
    <label className="floating-label">
      {label} {required ? <span className="a8-error">*</span> : null}
    </label>
    <Form.Item
      name={[name]}
      rules={[
        { ...rules },
        {
          pattern: regex.noTags,
          message: 'Input must not contain HTML or XML tags.',
        },
        {
          required,
          ...(onlyChars ? { pattern: regex.charsCheck } : {}),
          message,
        },
      ]}
      hasFeedback={required || !!value}
      style={style}
    >
      <TextArea
        className="custom-textarea-input"
        disabled={disabled}
        onChange={onChange}
        style={{ color: ConfigStyle.colors.subheading }}
        rows={rows}
      />
    </Form.Item>
  </div>
);

export default TextAreaInput;
